import type { ReceiptTemplate } from '../schema';

export const uberTemplate: ReceiptTemplate = {
  id: 'uber',
  name: 'Uber Receipt',
  brand: 'Uber',
  description: 'Ride receipt template inspired by Uber',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'uber-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'left',
        logoUrl: '/logos/uber.png',
        logoData: '',
        logoWidth: 150,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [],
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-date',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'right',
        dateTime: 'Sat, Oct 14, 2023',
        format: 'ddd, MMM DD, YYYY',
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-title',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: "Here's your updated ride receipt",
        fontSize: 14,
        isBold: true,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-subtitle',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'We hope you enjoyed your ride this evening.',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 16,
      },
    },
    {
      id: 'uber-total',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: 'uber-total-line', label: 'Total', value: '24.67', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: 'uber-trip-fare',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: 'uber-fare', label: 'Trip Fare', value: '21.35', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-3',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: 'uber-subtotal-section',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 0,
        lines: [
          { id: 'uber-subtotal', label: 'Subtotal', value: '21.35', isBold: true, isLarge: false },
          { id: 'uber-fees', label: 'Tolls, Surcharges and Fees', value: '3.32', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-4',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 16,
      },
    },
    {
      id: 'uber-charged-label',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Amount Charged',
        fontSize: 12,
        isBold: true,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-payment',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'uber-card', label: 'VISA', value: '.... 4608' },
        ],
        column2: [
          { id: 'uber-amount', label: '', value: '$24.67' },
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-5',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 16,
      },
    },
    {
      id: 'uber-driver',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'You rode with Jennifer',
        fontSize: 12,
        isBold: true,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-trip-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '2.4 miles | 18 min',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-spacer-6',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 8,
      },
    },
    {
      id: 'uber-pickup',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '7:23 PM | 1200 Dark Avenue, Monsterville CA',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'uber-dropoff',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '7:41 PM | 500 Scare Floor Blvd, Monsterville CA',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
  ],
};

